import PropTypes from 'prop-types';
import { CatTableCell } from '@blocks-react/components/TableCell';
import styles from '../ShareListDrawer.module.scss';

const ShareListNameCell = ({
  customerOrganizationBusinessName,
  customerOrganizationIdentifier
}) => {
  return (
    <CatTableCell>
      <div
        className={`${styles['share-list__name-truncate']} cat-u-theme-typography-body-sm`}
      >
        {customerOrganizationBusinessName}
      </div>
      <div className="cat-u-theme-typography-body-sm">
        {customerOrganizationIdentifier}
      </div>
    </CatTableCell>
  );
};

ShareListNameCell.propTypes = {
  customerOrganizationBusinessName: PropTypes.string,
  customerOrganizationIdentifier: PropTypes.string
};
export default ShareListNameCell;
